import React from 'react';

/** Asset decorativi: il nome accessibile resta sul controllo che li contiene. */
export const DashboardAreaIcon: React.FC<{ area: string }> = ({ area }) => (
  <img className="dash-area-art" src={`/dashboard-icons/${area}.png`} alt="" aria-hidden="true" width={36} height={36} />
);
